import {
  ExecutionStatusFilter,
  ExecutionStatusFilterEnum,
} from "@widgets/CampaignExecution/constants";

import { CheckCircle2, CheckSquare, Zap } from "lucide-react";
import styles from "./styles.module.scss";

export function CampaignExecutionEmptyState({
  activeStatusFilter,
}: {
  activeStatusFilter: ExecutionStatusFilter;
}) {
  return (
    <div className={styles.emptyState}>
      {activeStatusFilter === ExecutionStatusFilterEnum.All && (
        <>
          <div className={styles.emptyStateIcon}>
            <Zap size={32} className={styles.emptyStateIconColor} />
          </div>
          <h3 className={styles.emptyStateTitle}>No creators in execution</h3>
          <p className={styles.emptyStateDescription}>
            Once creators are hired, they will appear here to manage content and
            deliverables.
          </p>
        </>
      )}
      {activeStatusFilter === ExecutionStatusFilterEnum.ActionPending && (
        <>
          <div className={styles.emptyStateIconSuccess}>
            <CheckCircle2
              size={32}
              className={styles.emptyStateIconSuccessColor}
            />
          </div>
          <h3 className={styles.emptyStateTitle}>You're all caught up!</h3>
          <p className={styles.emptyStateDescription}>
            No pending actions for review or approval at this moment.
          </p>
        </>
      )}
      {activeStatusFilter === ExecutionStatusFilterEnum.Completed && (
        <>
          <div className={styles.emptyStateIcon}>
            <CheckSquare size={32} className={styles.emptyStateIconColor} />
          </div>
          <h3 className={styles.emptyStateTitle}>No completed creators yet</h3>
          <p className={styles.emptyStateDescription}>
            Creators who have finished all deliverables and gone live will
            appear here.
          </p>
        </>
      )}
    </div>
  );
}
